import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { verifiedInvalid } from '../../shared/helpers';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { forbiddenRut } from '../../shared/rut.validator';
import { rutClean } from 'rut-helpers';
import { HttpErrorResponse } from '@angular/common/http';
import { expRegEmail } from 'src/app/shared/email.regex';

@Component({
  selector: 'app-account-request',
  templateUrl: './account-request.component.html',
  styleUrls: ['./account-request.component.scss']
})
export class AccountRequestComponent implements OnInit {
  accountRequestForm: FormGroup;
  snackbarConfig: MatSnackBarConfig = { panelClass: 'account-request-snackbar', duration: 5000 };

  constructor(
    private fb: FormBuilder,
    private service: AuthenticationService,
    private snackBar: MatSnackBar
  ) {
  }

  get invalidRutProveedor(): boolean {
    return verifiedInvalid(this.accountRequestForm.get('rutProveedor'));
  }

  get invalidNombreProveedor(): boolean {
    return verifiedInvalid(this.accountRequestForm.get('nombreProveedor'));
  }

  get invalidName(): boolean {
    return verifiedInvalid(this.accountRequestForm.get('name'));
  }

  get invalidLastnames(): boolean {
    return verifiedInvalid(this.accountRequestForm.get('lastnames'));
  }

  get invalidEmail(): boolean {
    return verifiedInvalid(this.accountRequestForm.get('email'));
  }

  get invalidPhone(): boolean {
    return verifiedInvalid(this.accountRequestForm.get('phone'));
  }

  ngOnInit(): void {
    this.accountRequestForm = this.fb.group({
      rutProveedor: ['', [Validators.required, forbiddenRut()]],
      nombreProveedor: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+$/)]], // Sólo permitir primer nombre y apellido
      lastnames: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+$/)]],
      recaptcha: [null, Validators.required],
      email: ['', [Validators.required, Validators.pattern(expRegEmail)]],
      phone: ['', [Validators.required]],
    });
  }
  get rutProveedor(): string {
    return this.accountRequestForm.get('rutProveedor').value;
  }

  onChangeRut() {
    const rut = this.addGuion(rutClean(this.rutProveedor));
    this.service.provideName({
      OC_PROV_RUT: rut,
    }).then((resp) => {
      this.accountRequestForm.get('nombreProveedor').setValue(resp);
    }).catch(() => {
      this.accountRequestForm.get('rutProveedor').setErrors({ incorrect: true });
      this.accountRequestForm.get('nombreProveedor').setValue('');
    });
  }
  addGuion(rut: string): string {
    return rut.substring(0, rut.length - 1) + '-' + rut.substring(rut.length - 1, rut.length);
  }

  submit(): void {
    this.service.accountRequest({
      rut: this.accountRequestForm.get('rutProveedor').value,
      nombre: this.accountRequestForm.get('name').value.trim(),
      apellido: this.accountRequestForm.get('lastnames').value.trim(),
      email: this.accountRequestForm.get('email').value,
      telefono: `+56${this.accountRequestForm.get('phone').value}`,
    }, this.accountRequestForm.get('recaptcha').value).then(() => {
      this.snackBar.open('Su solicitud ha sido enviada correctamente'
        , 'cerrar', this.snackbarConfig);
      this.accountRequestForm.reset();
    }).catch((error: HttpErrorResponse) => {
      this.accountRequestForm.get('recaptcha').reset();
      this.snackBar.open('Ha ocurrido un problema procesando su solicitud', 'cerrar',
        this.snackbarConfig);
      if (error.error.statusCode === 401) {
        this.snackBar.open(error.error.message, 'cerrar', this.snackbarConfig);
      }
    });
  }

}
